<template>
  <div class="relyOnscrollContainer" v-loading="showLoading" element-loading-text="正在加载中">
    <div class="performSignList">
      <div
        class="performSignListItem"
        v-for="(item,index) in message"
        :key="index"
        :class="{'Complete':item.status=='',
                'Current':item.status=='current',
                'Unfinished':item.status=='unFinished'}"
      >
        <div class="itemMiddle">
          <div class="linePadding" :class="{'linePaddingActive':item.lineTop}"></div>
          <div class="itemDscp" :class="{'itemDscpActive':item.isComplete}">{{item.taskName}}</div>
          <div
            :class="{'linePaddingActive':item.lineBotttom}"
            class="linePadding linePaddingBottom"
          ></div>
        </div>
        <div class="itemList itemRightComplete">
          <div class="itemRight" v-for="itemTask in item.proforeTaskItemList" :key="itemTask.id">
            <div class="signPersonDetail">
              <div class="signPersonCol">
                <div class="taskItemName">{{itemTask.taskName}}</div>
                <div class="showDetailItem">
                  <div class="label">任务执行方：</div>
                  <div class="item">{{itemTask.performUserName}}</div>
                </div>
                <div class="showDetailItem">
                  <div class="label">确认方：</div>
                  <div class="item">{{itemTask.confirmUserName}}</div>
                </div>
              </div>
              <div class="signPersonCol">
                <div class="taskItemName"></div>
                <div class="showDetailItem">
                  <div class="label">最晚执行时间：</div>
                  <div class="item">{{itemTask.taskCommitTime}}</div>
                </div>
                <div class="showDetailItem">
                  <div class="label">最晚确认时间：</div>
                  <div class="item">{{itemTask.taskConfirmTime}}</div>
                </div>
              </div>
            </div>
            <div class="signPersonHandler" v-if="itemTask.confirmStatus!==1">
              <div class="currentStateDscp">
                <div style="color: #AAAAAA;">{{itemTask.performCreateTime}}&nbsp;&nbsp;创建</div>
              </div>
              <div class="currentStateDscp">
                <div
                  class="normalStyle"
                  :class="{'waitConfirm':itemTask.canRun&&judgeMyRole(itemTask)}"
                >
                  <span v-if="itemTask.perFormStatus==0&&itemTask.confirmStatus!==3">未提交</span>
                  <span v-if="itemTask.perFormStatus==3&&itemTask.confirmStatus==3">已过期</span>
                  <span
                    v-if="itemTask.perFormStatus!=3&&itemTask.confirmStatus!=3&&itemTask.perFormStatus!=0"
                  >{{itemTask.perFormStatusName + '&nbsp;&nbsp;' +(itemTask.confirmStatusName||'')}}</span>
                  <span
                    v-if="itemTask.canRun&&itemTask.role == 'perform'&&itemTask.confirmStatus!=1&&itemTask.perFormStatus!==3&&itemTask.confirmStatus!==3"
                  >剩余{{itemTask.taskCommitRemaining>0?itemTask.taskCommitRemaining:0}}天到期</span>
                  <span
                    v-if="itemTask.canRun&&itemTask.role == 'confirm'&&itemTask.confirmStatus!=1&&itemTask.confirmStatus!==3&&itemTask.perFormStatus!==3"
                  >剩余{{itemTask.taskConfirmRemaining>0?itemTask.taskConfirmRemaining:0}}天到期</span>
                </div>
              </div>
              <div class="handlerBox">
                <div
                  class="goReturn cursorPointer"
                  v-show="judgeIndex(itemTask.actionArray,2)"
                  @click="showDialog(2,itemTask)"
                >
                  <span class="icon"></span>撤回
                </div>
                <div
                  class="goSubmit cursorPointer"
                  v-show="judgeIndex(itemTask.actionArray,1)"
                  @click="showDialog(1,itemTask)"
                >
                  <span class="icon"></span>提交
                </div>
                <div
                  class="goReSubmit cursorPointer"
                  v-show="judgeIndex(itemTask.actionArray,6)"
                  @click="showDialog(5,itemTask)"
                >
                  <span class="icon"></span>重新提交
                </div>
                <div
                  class="goConfirm cursorPointer"
                  v-show="judgeIndex(itemTask.actionArray,4)"
                  @click="showDialog(3,itemTask)"
                >
                  <span class="icon"></span>确认
                </div>
                <div
                  class="goReject cursorPointer"
                  v-show="judgeIndex(itemTask.actionArray,5)"
                  @click="showDialog(4,itemTask)"
                >
                  <span class="icon"></span>驳回
                </div>
                <div
                  class="goTip cursorPointer"
                  v-show="judgeIndex(itemTask.actionArray,3)"
                  @click="tipPerson(itemTask.id)"
                >
                  <span class="icon"></span>提醒
                </div>
                <div class="goDetail cursorPointer" @click="evidenceFn(itemTask)">
                  <span class="icon"></span>详情
                </div>
              </div>
            </div>
            <div class="signPersonHandler" v-if="itemTask.confirmStatus==1">
              <div class="currentStateDscp">
                <div>{{itemTask.performCreateTime}}&nbsp;&nbsp;创建</div>
              </div>
              <div class="currentStateDscp">
                <div class="performComplete">履约已完成</div>
              </div>
              <div class="handlerBox">
                <div class="goDetail cursorPointer" @click="evidenceFn(itemTask)">
                  <span class="icon"></span>详情
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="borderImage"></div>
      </div>
      <Dialog :visible="dialogVisible" :dialogTitle="'提示'" @closeDialog="cancelFn" :width="'400px'">
        <div slot="dialog">
          <div class="hint">
            <p class="hintCon" v-if="actionType == 1">是否提交此任务？</p>
            <p class="hintCon" v-if="actionType == 2">是否撤回此任务？</p>
            <p class="hintCon" v-if="actionType == 3">是否确认此任务？</p>
            <p class="hintCon" style="width:300px;margin:0 auto" v-if="actionType == 4">
              <el-form
                ref="form"
                style="width:100%;padding-top:40px;box-sizing:border-box"
                :model="rejectForm"
                :rules="rules"
                label-width="0px"
              >
                <el-form-item prop="remark">
                  <el-input v-model="rejectForm.remark" type="textarea" placeholder="请输入驳回原因"></el-input>
                </el-form-item>
              </el-form>
            </p>
            <p class="hintCon" v-if="actionType == 5">是否重新提交此任务？</p>
            <p class="authHandlerBox" style="margin:0 auto">
              <span class="button cursorPointer" @click="cancelFn">取消</span>
              <span class="button buttonActive cursorPointer" @click="trueSubFn">确定</span>
            </p>
          </div>
        </div>
      </Dialog>
    </div>
  </div>
</template>
<script>
import BaseApi from "@lib/baseApi.js";
import Dialog from "@common/Dialog.vue";
export default {
  data() {
    return {
      state: "complete",
      dialogVisible: false,
      ArrayFlag: ["", "提交", "撤销", "确认", "驳回", "重新提交"],
      actionType: 0,
      actionTypeMessage: "",
      message: [],
      isRequest: false,
      showLoading: true,
      rejectForm: {
        remark: ""
      },
      rules: {
        remark: [{ max: 50, message: "驳回原因最多50个字符", trigger: "blur" }]
      }
    };
  },

  mounted() {},
  components: {
    Dialog
  },
  methods: {
    evidenceFn(itemTask) {
      this.$router.push({
        path: "/personal/performance/details",
        query: {
          id: itemTask.id,
          notCanRun: !itemTask.canRun ? "Y" : "N"
        }
      });
    },
    cancelFn() {
      this.dialogVisible = false;
    },
    showDialog(actionType, item) {
      this.actionType = actionType;
      this.actionMessage = this.ArrayFlag[actionType];
      this.currentItem = item;
      this.dialogVisible = true;
    },
    setData(arr) {
      this.message = arr;
      this.handlerArray(arr);
      this.isRequest = false;
      this.showLoading = false;
    },
    judgeIndex(arr, value) {
      if (arr && arr.length && arr.indexOf(value) > -1) {
        return true;
      } else {
        return false;
      }
    },
    tipPerson(id) {
      BaseApi.createRpcToken("/perform/performRemind", {
        id: id
      })
        .then(
          data => {
            this.$message.success("提醒" + "成功");
          },
          data => {
            console.log(data);
          }
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    judgeState(item) {
      console.log(item);
      for (let i = 0; i < item.proforeTaskItemList.length; i++) {
        if (item.periodSequen == 0) {
          if (
            item.proforeTaskItemList[i].confirmStatus != 1 &&
            !(
              item.proforeTaskItemList[i].confirmStatus == 3 ||
              item.proforeTaskItemList[i].perFormStatus == 3
            )
          ) {
            return false;
          }
        } else {
          if (item.proforeTaskItemList[i].confirmStatus != 1) {
            return false;
          }
        }
      }
      return true;
    },
    judgeCanRun(item) {
      if (!item.previousPerformId) {
        return true;
      } else {
        for (let i = 0; i < this.message.length; i++) {
          if (item.previousPerformId == this.message[i].taskId) {
            if (this.message[i + 1].taskId == item.taskId) {
              this.message[i].lineBotttom = true;
              this.message[i + 1].lineTop = true;
            }
            return this.message[i].isComplete;
          }
        }
        return false;
      }
    },
    judgeHandler(myRole, itemValue) {
      let actionArray = [];
      if (myRole == "perform") {
        if (itemValue.perFormStatus == 0) {
          actionArray.push(1);
        } else if (
          itemValue.perFormStatus == 1 &&
          itemValue.confirmStatus == 0
        ) {
          actionArray.push(2, 3);
        } else if (
          itemValue.confirmStatus == 2 ||
          itemValue.perFormStatus == 2
        ) {
          actionArray.push(6);
        }
      }
      if (myRole == "confirm") {
        if (itemValue.perFormStatus == 0) {
          actionArray.push(3);
        } else if (
          itemValue.perFormStatus == 1 &&
          itemValue.confirmStatus == 0
        ) {
          actionArray.push(4, 5);
        }
      }
      itemValue.actionArray = actionArray;
    },
    handlerArray(arr) {
      arr.forEach(value => {
        value.isComplete = this.judgeState(value);
        let canRun = this.judgeCanRun(value);
        let isMore = false;
        if (value.proforeTaskItemList.length > 1) {
          isMore = true;
        }
        if (value.periodSequen == 0) {
          value.proforeTaskItemList.forEach((itemValue, index) => {
            itemValue.canRun = canRun;
            let myRole = this.judgeMyRole(itemValue);
            if (canRun) {
              this.judgeHandler(myRole, itemValue);
            }
          });
        } else {
          value.proforeTaskItemList.forEach((itemValue, index) => {
            if (index == 0) {
              itemValue.canRun = canRun;
            }
            if (isMore && index !== value.proforeTaskItemList.length - 1) {
              if (itemValue.confirmStatus == 1) {
                value.proforeTaskItemList[index + 1].canRun = true;
              }
            }
            let myRole = this.judgeMyRole(itemValue);
            if (itemValue.canRun) {
              //可执行的操作数组 1提交 2撤回 3提醒 4确认 5驳回
              this.judgeHandler(myRole, itemValue);
            }
          });
        }
      });
      return arr;
    },
    judgeMyRole(item) {
      if (item.performUserId == localStorage.userId) {
        item.role = "perform";
        return "perform";
      } else if (item.confirmUserId == localStorage.userId) {
        item.role = "confirm";
        return "confirm";
      } else {
        item.role = "";
        return "";
      }
    },
    trueSubFn() {
      if (!this.isRequest) {
        this.dialogVisible = false;
        this.showLoading = true;
        this.isRequest = true;
        var queryStr = {
          actionType: this.actionType,
          id: this.currentItem.id
        };
        this.actionType === 4 && this.rejectForm.remark
          ? (queryStr.remark = this.rejectForm.remark)
          : "";
        BaseApi.createRpcToken(
          "/perform/performRecordToChain",
          queryStr,
          "post",
           false,
          false,
          false
        )
          .then(
            data => {
              this.$message.success(this.actionMessage + "成功");
              this.$emit("getDetail");
              this.dialogVisible = false;
              // 这里不改变isRequest的值,在父组件中调用中更改
            },
            data => {
               if (data.code == "437") {
                this.$message.error(data.message || "抱歉暂时无法处理您的请求");
                this.$emit("getDetail");
              } else {
                this.$message.error(data.message || "抱歉暂时无法处理您的请求");
                this.isRequest = false;
                this.showLoading = false;
              }
            }
          )
          .catch(function(e) {
            errorLog(e);
          });
      }
    }
  },
  created() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.relyOnscrollContainer {
  height: 100%;
  overflow: hidden;
}
.performSignList {
  width: 100%;
  box-sizing: border-box;
  height: 100%;
  overflow-y: scroll;
  .performSignListItem {
    width: 100%;
    height: auto;
    display: flex;
    position: relative;
    .itemMiddle {
      display: flex;
      flex-direction: column;
      align-items: center;
      .itemDscp {
        width: 162px;
        box-sizing: border-box;
        padding: 0 15px;
        height: 36px;
        line-height: 36px;
        background: #f0f0f0;
        overflow: hidden; /*自动隐藏文字*/
        text-overflow: ellipsis; /*文字隐藏后添加省略号*/
        white-space: nowrap; /*强制不换行*/
        font-size: 14px;
        color: #969696;
        text-align: center;
      }
      .itemDscpActive {
        background: #ffeded;
        color: #fd9490;
      }
      .linePadding {
        height: 28px;
        width: 0px;
        border: 1px dashed #fd9490;
        flex: 1;
      }
      .linePaddingActive {
        border: 1px solid #fd9490;
      }
      .linePaddingBottom {
        height: 48px;
      }
      .middleState {
        height: 24px;
        width: 24px;
      }
    }
    .itemList {
      flex: 1;
      justify-content: space-between;
      padding: 0 20px;
      box-sizing: border-box;
      position: relative;
      margin-left: 20px;
      background: #ffffff;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      border: 1px solid #edf0f4;
      margin-bottom: 10px;
      margin-top: 10px;
      .itemRight {
        flex: 1;
        justify-content: space-between;
        box-sizing: border-box;
        position: relative;
        background: #ffffff;
        display: flex;
        padding: 20px 0;
        justify-content: space-between;
        border-bottom: 1px solid #edf0f4;
      }
      & > .itemRight:last-child {
        border: none;
      }
    }

    .borderImage {
      position: absolute;
      height: 80px;
      width: 10px;
      top: 0;
      left: 173px;
    }
    .goDetail {
      color: #969696;
      .icon {
        background: url("./../../../../../assets/images/personalSignPerform/details_icon_nor.png");
      }
      &:hover {
        .icon {
          background: url("./../../../../../assets/images/personalSignPerform/details_icon_hov_pre.png");
        }
        color: #e88078;
      }
    }
    .goReturn {
      color: #969696;
      .icon {
        background: url("./../../../../../assets/images/personalSignPerform/revocation_icon_nor.png");
      }
      &:hover {
        .icon {
          background: url("./../../../../../assets/images/personalSignPerform/revocation_icon_hov_pre.png");
        }
        color: #e88078;
      }
    }
    .goSubmit {
      color: #969696;
      .icon {
        background: url("./../../../../../assets/images/personalSignPerform/submit_icon_nor.png");
      }
      &:hover {
        .icon {
          background: url("./../../../../../assets/images/personalSignPerform/submit_icon_hov_pre.png");
        }
        color: #e88078;
      }
    }
    .goReSubmit {
      color: #969696;
      .icon {
        background: url("./../../../../../assets/images/personalSignPerform/resubmit_icon_nor.png");
      }
      &:hover {
        .icon {
          background: url("./../../../../../assets/images/personalSignPerform/resubmit_icon_hov_pre.png");
        }
        color: #e88078;
      }
    }
    .goConfirm {
      color: #969696;
      .icon {
        background: url("./../../../../../assets/images/personalSignPerform/confirm_icon_nor.png");
      }
      &:hover {
        .icon {
          background: url("./../../../../../assets/images/personalSignPerform/confirm_icon_hov_pre.png");
        }
        color: #e88078;
      }
    }
    .goReject {
      color: #969696;
      .icon {
        background: url("./../../../../../assets/images/personalSignPerform/reject_icon_nor.png");
      }
      &:hover {
        .icon {
          background: url("./../../../../../assets/images/personalSignPerform/reject_icon_hov_pre.png");
        }
        color: #e88078;
      }
    }
    .goTip {
      color: #969696;
      .icon {
        background: url("./../../../../../assets/images/personalSignPerform/remind_icon_nor.png");
      }
      &:hover {
        .icon {
          background: url("./../../../../../assets/images/personalSignPerform/remind_icon_hov_pre.png");
        }
        color: #e88078;
      }
    }
    .signPersonDetail {
      display: flex;
      .signPersonCol {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .taskItemName {
          font-size: 14px;
          color: #969696;
          height: 18px;
          line-height: 18px;
          font-weight: 600;
          padding-bottom: 5px;
        }
        .showDetailItem {
          display: flex;
          font-size: 14px;
          line-height: 14px;
          color: #aaaaaa;
          padding: 5px 0;
          .label {
            width: 100px;
            color: #969696;
            margin-right: 20px;
          }
          .item {
            color: #aaaaaa;
          }
        }
      }
      & > .signPersonCol:first-child {
        margin-right: 40px;
        .label {
          width: 84px;
        }
      }
    }
    .signPersonHandler {
      font-size: 12px;
      line-height: 12px;
      text-align: right;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .currentStateDscp {
        .performComplete {
          color: #3dac3d;
        }
        .normalStyle {
          color: #b4b4b4;
        }
        .waitConfirm {
          color: #fd9490;
        }
      }
    }
    .handlerBox {
      display: flex;
      justify-content: flex-end;
      div {
        line-height: 14px;
        margin-left: 20px;
      }
      .icon {
        display: inline-block;
        width: 14px;
        height: 14px;
        vertical-align: middle;
        margin-right: 5px;
        margin-top: -3px;
      }
    }
  }

  .Complete {
    .itemRight {
      background-color: #f5f5f5;
      border: 1px dashed #dcdcdc;
    }
    .borderImage {
      background: url("./../../../../../assets/images/personalSignPerform/triangle_past_img.jpg");
      background-size: 10px 80px;
    }
    .itemMiddle {
      .middleState {
        background: url("./../../../../../assets/images/personalSignPerform/group_3_copy.png");
        background-size: 24px 24px;
      }
    }
  }
  .Current {
    .itemLeft {
      color: #e88078;
    }
    .itemRight {
      border: 1px solid #ebebeb;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
    }
    .borderImage {
      background: url(" ");
      background-size: 10px 80px;
    }
    .signPersonDetail {
      .signPersonCol {
        .showDetailItem {
          .label {
            color: #787878;
          }
          .item {
            color: #787878;
          }
        }
      }
    }
    .itemMiddle {
      .middleState {
        background: url(./../../../../../assets/images/personalSignPerform/group_2.png);
        background-size: 24px 24px;
      }
      .linePadding:last-child {
        background: #e5e8ef;
      }
    }
  }
  .Unfinished {
    .itemRight {
      border: 1px dashed #dcdcdc;
    }
    .borderImage {
      background: url(./../../../../../assets/images/personalSignPerform/triangle_nobegun_img.jpg);
      background-size: 10px 80px;
    }
    .signPersonDetail {
      .signPersonCol {
        .showDetailItem {
          .label {
            color: #787878;
          }
          .item {
            color: #969696;
          }
        }
      }
    }
    .itemMiddle {
      .middleState {
        background: url(./../../../../../assets/images/personalSignPerform/circlenoshow_icon.png);
        background-size: 24px 24px;
      }
      .linePadding {
        background: #e5e8ef;
      }
    }
  }
}
.hint {
  height: 200px;
  .hintCon {
    text-align: center;
    height: 137px;
    line-height: 137px;
  }
  .operate {
    padding: 0 80px;
    span {
      display: inline-block;
      width: 100px;
      height: 32px;
      text-align: center;
      line-height: 32px;
      border: 1px solid #c8c8c8;
      font-size: 12px;
      color: #646464;
    }
    span:first-child {
      border: 1px solid #db4437;
      color: #db4437;
    }
  }
}
</style>
